<template>
    <div class="page">
        <div class="top text-center">开福消防签到系统欢迎您！</div>
        <p class="sign-name text-center">您是第{{ number }}位签到者</p>
        <p class="sign-address text-center">
            单位名称：长沙市开福区潮宗街政府专职消防救援站
        </p>
        <div class="sign-container">
            <div class="left">
                <div class="photo-box">
                    <img
                        src="../assets/head-img.png"
                        alt=""
                        class="head-img"
                        v-if="showHeadImg"
                    />
                    <video
                        ref="video"
                        width="520"
                        height="400"
                        :class="showVideo ? 'show' : 'hide'"
                        autoplay
                    ></video>
                    <canvas
                        ref="canvas"
                        width="300"
                        height="400"
                        :class="
                            !showVideo
                                ? 'photo-canvas show'
                                : 'photo-canvas hide'
                        "
                    ></canvas>
                </div>
                <button class="sign-btn" @click="callCamera" v-if="showBegin">
                    开始拍摄
                </button>
                <button class="sign-btn" @click="photograph" v-if="showEnter">
                    确认拍摄
                </button>
                <button
                    class="sign-btn again-btn"
                    @click="againPhoto"
                    v-if="showAgain"
                >
                    重新拍摄
                </button>
            </div>
            <div>
                <div class="sign-box">
                    <vue-esign
                        ref="esign"
                        :width="800"
                        :height="360"
                        :isCrop="isCrop"
                        :lineWidth="lineWidth"
                        :lineColor="lineColor"
                        :bgColor.sync="bgColor"
                    />
                    <button @click="handleReset" class="cancel-btn">
                        <img src="../assets/cancel_icon.png" alt="" />
                        重签
                    </button>
                </div>
                <button @click="handleGenerate" class="sign-btn long">
                    开始签到
                </button>
            </div>
        </div>
        <div class="mask-content" v-if="showMask">
             <p>您还未签名</p>
             <button class="sign-btn" @click="hideMask">确定</button>
        </div>
    </div>
</template>

<script>
export default {
    name: "home",
    data() {
        return {
            lineWidth: 6,
            lineColor: "#000000",
            bgColor: "rgb(255,255,255)",
            resultImg: "",
            isCrop: false,
            baseUrl: "http://kfxf.vip.api.hnlinghou.com/",
            number: "",
            showHeadImg: true,
            showBegin: true,
            showVideo: true,
            showEnter: false,
            showAgain: false,
            showMask:false,
            photo:''
        };
    },
    created() {
        this.$http
            .get(this.baseUrl)
            .then((res) => {
                // console.log(res)
                this.number = res.data;
            })
            .catch((err) => {});
    },
    methods: {
        hideMask(){
            this.showMask = false;
        },
        // 调用摄像头
        callCamera() {
            this.showHeadImg = false;
            this.showBegin = false;
            this.showEnter = true;
            // H5调用电脑摄像头API
            navigator.mediaDevices
                .getUserMedia({
                    video: true,
                })
                .then((success) => {
                    // 摄像头开启成功
                    this.$refs["video"].srcObject = success;
                    // 实时拍照效果
                    this.$refs["video"].play();
                })
                .catch((error) => {
                    console.error(error);
                    alert(error);
                    this.showBegin = true;
                    this.showHeadImg = true;
                    this.showEnter = false;
                });
        },

        // 拍照
        photograph() {
            let ctx = this.$refs["canvas"].getContext("2d");
            // 把当前视频帧内容渲染到canvas上
            ctx.drawImage(this.$refs["video"], 0, 0, 520, 400);

            this.showVideo = false;
            this.showEnter = false;
            this.showAgain = true;

            // 转base64格式、图片格式转换、图片质量压缩
            let imgBase64 = this.$refs["canvas"].toDataURL("image/jpeg", 0.7); // 由字节转换为KB 判断大小

            //   let str = imgBase64.replace("data:image/jpeg;base64,", "");
            console.log(imgBase64);
            let imgUrl = this.base64ImgtoFile(imgBase64);

   
            var file = imgUrl;
            var formdata = new FormData();
            formdata.append("file", file, file.name);

            this.$http
                .post(this.baseUrl + "index/upload/file", formdata)
                .then((res) => {
                    var url = res.data.url;
                    console.log('https://oss.kaifahou.com/'+ url);
                    this.photo = res.data.url;
                })
                .catch((err) => {});
        },
        // 重新拍摄
        againPhoto() {
            this.showVideo = true;
            this.showEnter = true;
            this.showAgain = false;
        },
        handleReset() {
            this.$refs["esign"].reset(); //清空画布
            this.bgColor = "rgba(255,255,255,1)";
        },
        handleGenerate() {
            let _this = this;
            this.$refs["esign"]
                .generate()
                .then((res) => {
                    _this.resultImg = res; // 得到了签字生成的base64图片
                    _this.resultImg = _this.base64ImgtoFile(_this.resultImg);

                    var file = _this.resultImg;
                    var formdata = new FormData();
                    formdata.append("file", file, file.name);
                    // console.log(formdata.get('file'))
                    // let config = {
                    //     headers: {
                    //         headers: { "Content-Type": "multipart/form-data" },
                    //     },
                    // };
                    _this.$http
                        .post(this.baseUrl + "index/upload/file", formdata)
                        .then((res) => {
                            var url = res.data.url;
                            console.log(url);
                            _this.$router.push({
                                path: "/success",
                                query: { url: url, num: _this.number,photo:_this.photo },
                            });
                        })
                        .catch((err) => {});
                })
                .catch((err) => {
                    console.log(err);
                    //  没有签名，点击生成图片时调用
                    _this.showMask = true;
                    // alert("未签名"); // 画布没有签字时会执行这里 'Not Signned'
                });
        },

        base64ImgtoFile(dataurl, filename = "file") {
            const arr = dataurl.split(",");
            const mime = arr[0].match(/:(.*?);/)[1];
            const suffix = mime.split("/")[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], `${filename}.${suffix}`, {
                type: mime,
            });
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
    min-height: 100vh;
    background: url("../assets/bg.png") no-repeat;
    background-size: cover;
}
.mask-content{
    width: 900px;
    height: 560px;
    background: rgba(0, 0, 0, 0.79);
    border-radius: 10px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    text-align: center;
}
.mask-content p{
    font-size: 60px;
    color: #fff;
    margin: 150px auto 110px;
}
.top {
    height: 120px;
    line-height: 120px;
    color: #fff;
    background: rgba(0, 0, 0, 0.29);
    font-size: 42px;
}
.sign-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
}
.sign-container .left {
    margin-right: 100px;
}

.photo-box {
    width: 300px;
    height: 400px;
    background: rgba(255, 255, 255, 0.4);
    box-shadow: 0px 0px 20px 10px rgba(77, 16, 15, 0.38);
    border-radius: 10px;
    text-align: center;
    position: relative;
    overflow: hidden;
}
.photo-box .head-img {
    /* margin-top: 62px; */
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
.photo-canvas {
    position: absolute;
    top: 0;
    bottom: 0;
}
.photo-box video {
    position: absolute;
    top: 0;
    bottom: 0;
    object-fit: cover;
}
.hide {
    left: -100%;
}
.show {
    left: 0;
}

.videoshow {
    left: -130px;
}
.sign-box {
    width: 800px;
    height: 400px;
    background: rgba(255, 255, 255);
    box-shadow: 0px 0px 20px 10px rgba(77, 16, 15, 0.38);
    border-radius: 10px;
    position: relative;
    overflow: hidden;
}
.sign-name {
    font-size: 60px;
    color: #ffc776;
    margin: 80px 0 30px;
}
.sign-address {
    font-size: 20px;
    color: #fff;
}
.sign-btn {
    display: block;
    width: 250px;
    height: 90px;
    background: #e9a23c;
    border-radius: 10px;
    line-height: 90px;
    margin: 70px auto 0;
    color: #3a2200;
    font-size: 42px;
}
.sign-btn.long {
    width: 328px;
}
.sign-btn.again-btn {
    background: #fff;
}
.cancel-btn {
    background: transparent;
    padding: 20px;
    font-size: 30px;
    display: flex;
    align-items: center;
    position: absolute;
    right: 0;
    bottom: 0;
}
.cancel-btn img {
    margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/home.vue